import { nursingApi } from './nursingApi';
import { nursingHelpers } from './nursingHelpers';

export const nursingService = {
  ...nursingApi,
  ...nursingHelpers,
};

export * from './types';
